import { AiOutlineSend, AiOutlineUnorderedList, AiOutlineDownload, AiFillHome,AiOutlineFlag } from "react-icons/ai";
  
  export const tabs = [
    {
      to: '/home',
      value: 'home',
      label: 'Home',
      icon: <AiFillHome/>
    },
    {
      to: '/filters',
      value: 'filters',
      label: 'Filters',
      icon: <AiOutlineUnorderedList />,
    },
    {
      to: '/send',
      value: 'send',
      label: 'Send',
      icon: <AiOutlineSend/>,
    },
    {
      to: '/download',
      value: 'download',
      label: 'Download',
      icon: <AiOutlineDownload/>,
    },
    {
      to: '/territories',
      value: 'territories',
      label: 'Territories',
      icon: <AiOutlineFlag/>,
    },
  ]; 